import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ISystemTransactions } from '~/models/modules/Common/systemTransactions';
import { ISystemTransactionsFields } from '~/models/modules/Common/systemTransactionsFieldsDto';
import { SystemTransactionsFieldsService } from '~/services/modules/common/system-transactions-fields.service';
import { SystemTransactionsService } from '~/services/modules/common/system-transactions.service';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutComponent } from '../layout/layout.component';

@Component({
    selector: 'asap-transactions-fields-editor',
    templateUrl: './transactions-fields-editor.component.html',
    styleUrls: ['./transactions-fields-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransactionsFieldsEditorComponent implements OnInit {

  _transactions:ISystemTransactions[] = [];
  _transactionFields:ISystemTransactionsFields[];
  _theme: string;


  //entity
  _entity:string = '';
  @Input()
  get entity(): string{
    return this._entity;
  }
  set entity(input: string){
    this._entity = input;
  }

  //@Input() title:string = 'Edit Field Visibility';
//showFieldEditor
 /*  _showFieldEditor:boolean = false;
  @Input()
  get showFieldEditor(): boolean{
    return this._showFieldEditor;
  }
  set showFieldEditor(input: boolean){
    this._showFieldEditor = input;
  } */

//Page Name
  _pageName:string = '';
  @Input()
  get pageName(): string{
    return this._pageName;
  }
  set pageName(input: string){
    this._pageName = input;
  }

//Object Code
  _fieldObjectCode:string = '';
  @Input()
  get fieldObjectCode(): string{
    return this._fieldObjectCode;
  }
  set fieldObjectCode(input: string){
    this._fieldObjectCode = input;
  }


  @Output() CloseWindowHandler:EventEmitter<boolean> = new EventEmitter();
  constructor(
    private _systemTransactionsService: SystemTransactionsService,
    private _systemTransactionsFieldsService: SystemTransactionsFieldsService,
    private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    //this.loadTransactions();
    //this.loadTransactionsWithFields();
    this.loadFieldTransactions();
  }


  onCloseWindow(close: boolean){
    this.CloseWindowHandler.emit(close);
  }
  onSave(e:string){
    this._systemTransactionsFieldsService.createFieldRange(this._transactionFields)
    
    .subscribe((data:boolean) => {
      if(data == true){
        this._layoutComponent.openPopup({
          title: 'Alert',
          message: 'Saved Successfully',
          withoutConfirm: true
        });
        if(e == 'SaveAndClose') {
          this.onCloseWindow(true);
        }
      }
    });
  }

  loadTransactions(){
    if(this.entity == 'asset'){
      this._systemTransactionsService.getAssetTransactions()
      
      .subscribe((data:ISystemTransactions[]) => {
        this._transactions = [...data];
      });
    }
    else
    if(this.entity == 'stock'){
      this._systemTransactionsService.getStockTransactions()
      
      .subscribe((data:ISystemTransactions[]) => {
        this._transactions = [...data];
      });
    }
  }
  loadTransactionsWithFields(){
    this._systemTransactionsFieldsService.getFieldsByPageName(this._pageName)
    
    .subscribe((data:ISystemTransactionsFields[]) => {
      this._transactionFields = [...data];
    });
  }
  loadFieldTransactions(){
    this._systemTransactionsFieldsService.getFieldByObjectCode(this._fieldObjectCode, this._pageName)
    
    .subscribe((data:ISystemTransactionsFields[]) => {
      this._transactionFields = [...data];
    });
  }
}
